import { Injectable } from '@angular/core';
import { saveAs } from '@progress/kendo-file-saver';
import { Workbook } from '@progress/kendo-ooxml';
import * as ExcelJS from 'exceljs';
import { LoadingService } from '../services/loading-progress-bar.service';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(private loadingService: LoadingService) { }
  public exportExcel(jsonData: any[], excelHeader: any, fileName: string): void {
    this.onExportExcel(jsonData, excelHeader, fileName);
  }

  private async onExportExcel(jsonData: any[], excelHeader: any, fileName: string) {
    this.loadingService.setLoading(true);
    let dataRows: any[] = [];
    let cells: any[] = [];

    // Header Row Adding
    excelHeader.forEach((x: string) => {
      cells = [];
      Object.keys(x).forEach((prop: any) => {
        cells.push(x[prop]);
      });
      dataRows.push(cells);
    });

    // Value Row Adding
    jsonData.forEach((x: any) => {
      cells = [];
      Object.keys(x).forEach((prop: any) => {
        cells.push(x[prop]);
      })

      dataRows.push(cells);
    });

    let workbook = new ExcelJS.Workbook();
    let worksheet = workbook.addWorksheet('Sheet1');

    for (let i = 0; i < dataRows.length; i += 1000) {
      const batch = dataRows.slice(i, i + 1000);
      worksheet.addRows(batch);
      await new Promise(resolve => setTimeout(resolve, 0)); // Yield to the event loop
    }

    // Finalize workbook to optimize styles
    this.finalizeWorkbook(workbook);

    await workbook.xlsx.writeBuffer().then(buffer => {
      let blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, fileName);
    }).catch()
      .finally(() => {
        this.loadingService.setLoading(false);
      });
  }

  finalizeWorkbook(workbook: ExcelJS.Workbook) {
    const internedStyles = new Map();
    workbook.worksheets.forEach(worksheet => {
      worksheet.eachRow(row => {
        row.eachCell(cell => {
          const styleKey = JSON.stringify(cell.style);
          if (!internedStyles.has(styleKey)) {
            internedStyles.set(styleKey, Object.freeze({ ...cell.style }));
          }
          cell.style = internedStyles.get(styleKey);
        });
      });
    });
  }

}
